module.exports = __webpack_public_path__ + "img/guild_of_shadows_small.90f71540.png";